import {
  APPLICATION_STATUS_FALLBACK_LABEL,
  APPLICATION_TYPE_FALLBACK_LABEL,
  EXTERNAL_APPLICATION_STATUS_FALLBACK_LABEL,
  INTERNAL_APPLICATION_STATUS_FALLBACK_LABEL,
  type ApplicationStatus,
} from "../../constants";
import { APPLICATION_STATUS_TO_UI_STATUS } from "../../components/application-status-ui";
import type { CreateApplicationCategory } from "../create-application-page/create-application-page.lib";

export type { ApplicationStatus };

export type ApplicationUiStatus = "NEUTRAL" | "IN_QUEUE" | "SUCCESS" | "ERROR" | "TO_REUPLOAD";

export const APPLICATION_CATEGORY_LABEL: Record<CreateApplicationCategory, string> = {
  adjacent: "Примыкание",
  crossing: "Пересечение",
};

export {
  APPLICATION_TYPE_FALLBACK_LABEL,
  APPLICATION_STATUS_FALLBACK_LABEL,
  EXTERNAL_APPLICATION_STATUS_FALLBACK_LABEL,
  INTERNAL_APPLICATION_STATUS_FALLBACK_LABEL,
  APPLICATION_STATUS_TO_UI_STATUS,
};
